import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Loader from '../../../general/Loader';
import { fc, useI18n } from '../../../../../i18n';
import ScrollList from '../../../general/list/ScrollList';
import ReportSummary from './ReportSummary';
import ReportHeader from './ReportHeader';
import { actions } from '../../../../redux/api/reports';
import NoDataView from '../../../general/view/NoDataView';
import { getAssetType } from 'core/misc/assetTypes';
import { className } from 'core/lib/className';

import './deviceUsages.scss';

function HeaderListItem({ groupingId, isAssetTypes }) {
	const { f } = useI18n();
	return (
		<>
			<div className="header-item">
				<span className="capitalize">{f('item No.')}</span>
			</div>
			<div className="header-item">
				<span className="capitalize">{f('device')}</span>
			</div>
			{!!groupingId && (
				<div className="header-item">
					<span className="capitalize">{fc('group')}</span>
				</div>
			)}
			{!!isAssetTypes && (
				<div className="header-item">
					<span className="capitalize">{fc('asset type')}</span>
				</div>
			)}
			<div className="header-item">
				<span className="capitalize">{f('days')}</span>
			</div>
			<div className="header-item">
				<span className="capitalize">{f('trips')}</span>
			</div>
			<div className="header-item">
				<span className="capitalize">{f('distance') + ', ' + f('units.km')}</span>
			</div>
		</>
	);
}

function ReportListItem({ usage, index, device, group, assetType }) {
	return (
		<>
			<div>{index}</div>
			<div>{device && device.denomination()}</div>
			{!!group && <div>{group}</div>}
			{!!assetType && <div>{fc(assetType)}</div>}
			<div>{usage.days}</div>
			<div>{usage.trips}</div>
			<div>{usage.distance}</div>
		</>
	);
}

function EodListItem() {
	const { f } = useI18n();
	return (
		<div className="indicator">
			<span className="capitalize">{f('you have reached the end')}</span>
		</div>
	);
}

function DeviceUsages(props) {
	const { state, categoryMap, devices } = props;

	const { f } = useI18n();
	const dispatch = useDispatch();

	let content = null;
	let canExport = false;

	const getDeviceGroup = (device) => {
		let deviceGroup = '-';

		if (!device.categoryIds) {
			return deviceGroup;
		}

		device.categoryIds.forEach((categoryId) => {
			const category = categoryMap[categoryId];
			const comprisingIds = category?.comprisingIds;

			if (comprisingIds) {
				if (state.parameters.groupingId && comprisingIds.includes(state.parameters.groupingId))
					deviceGroup = category.name;
			}
		});

		return deviceGroup;
	};

	if (state.list != null) {
		if (!state.list || state.list.length == 0) {
			content = <NoDataView message={f('no data for such criteria')} />;
		} else {
			canExport = true;
			let items = state.list.map((usage, at) => {
				const device = devices ? devices[usage.uri] : null;
				const assetType = state.parameters.isAssetTypes ? getAssetType(device.categoryIds)?.getName() || '-' : null;

				return (
					<ReportListItem
						key={at}
						usage={usage}
						index={at + 1}
						device={device}
						assetType={assetType}
						group={state.parameters.groupingId && device ? getDeviceGroup(device) : null}
					/>
				);
			});
			items.unshift(
				<HeaderListItem
					key={1000000}
					groupingId={state.parameters.groupingId}
					isAssetTypes={state.parameters.isAssetTypes}
				/>,
			);
			content = (
				<ScrollList pending={state.pending} isEod={!state.hasMore} eodItem={EodListItem}>
					{items}
				</ScrollList>
			);
		}
	} else {
		content = (
			<div className="center">
				{state.error ? <span className="error">{state.error}</span> : <Loader size={Loader.Size.MD} />}
			</div>
		);
	}

	const exportReport = () => {
		dispatch(actions.deviceUsages.export());
		props.history.goBack();
	};

	const timeRange = state.parameters.timeRange;
	return (
		<div className={className("report device-usages", {
			"with-group": !!state.parameters.groupingId,
			"with-asset-type": !!state.parameters.isAssetTypes
		})}>
			<ReportHeader title={f('device usages report')} canExport={canExport} onExport={exportReport} />
			<ReportSummary since={timeRange.since} until={timeRange.until} generatedAt={state.at} />
			<div className="content">{content}</div>
		</div>
	);
}

export default withRouter(
	connect((state) => {
		return {
			state: state.reports.deviceUsages,
			devices: state.devices.map,
			categoryMap: state.categories.general.map,
		};
	})(DeviceUsages),
);
